import React from "react";

import { NotificationStatuses } from "@jsainsburyplc/id-ui-common";

import NotificationPage from "../../NotificationPage";
import ForgottenPasswordLink from "../ForgottenPasswordLink";

const PasswordExpiredNotification = () => (
  <NotificationPage
    type={NotificationStatuses.ERROR_TYPE}
    title="Your password has expired"
    warningInfo="You won’t be able to access your account until you reset your password."
    info="To reset your password, just follow the link below."
    action={<ForgottenPasswordLink />}
  />
);

export default PasswordExpiredNotification;
